// extracted by css-extract-rspack-plugin
export default {"wrapper":"_9bcebb52"};